var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBattery5Black(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M703.1,890h-80c-10,0-15-5-20-15s-5-15,0-25l125-180c5-5,10-5,15-5c5,0,10,5,10,10v110h75c10,0,15,5,20,15s5,15,0,25 l-125,180c-5,5-10,5-15,5c-5,0-10-5-10-10V890H703.1z M278.1,1040c-15,0-25-5-35-15c-10-10-15-20-15-35V190c0-15,5-25,15-35 c10-10,20-15,35-15h100V90c0-15,5-25,15-35c10-10,20-15,35-15h100c15,0,25,5,35,15c10,10,15,20,15,35v50h100c15,0,25,5,35,15 c10,10,15,20,15,35v350c-20,0-35,0-50,5c-15,5-35,5-50,15V240h-300v700h120c5,20,15,35,25,55c10,15,20,30,35,45L278.1,1040 L278.1,1040z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery5Black);
export default __webpack_public_path__ + "static/media/battery-5-black.b369a91f1740b62fff0737351ab0ec95.svg";
export { ForwardRef as ReactComponent };